<template>
  <div class="wrap" :class="{ 'wrap-point': !disabled }" @click="onClick">
    <img class="avatar" v-if="src" :src="src" />
    <div class="avatar avatar-upload" v-else></div>

    <span class="name">{{ userName || '请选择' }}</span>
  </div>
</template>

<script>
export default {
  name: "select-person",
  components: {},
  props: {
    disabled: Boolean,
    src: String,
    userName: String
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onClick() {
      if (this.disabled) return;
      this.$emit("click");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.wrap {
  width: 1rem;
  height: 1.28rem;
  border: 1px solid #dedede;
  border-radius: 4px;

  .flex(center, center, @flexDirection:column);
}
.wrap-point {
  cursor: pointer;
}
.avatar,
.avatar-upload {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: #eee;
}
.avatar-upload {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;

    height: 1px;
    width: 18px;
    background-color: #d3d3d3;
    transform: translate(-50%, -50%);
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;

    height: 18px;
    width: 1px;
    background-color: #d3d3d3;
    transform: translate(-50%, -50%);
  }
}
.name {
  font-size: 14px;
  margin-top: 7px;
  color: #999;
}
</style>
